import React, { useEffect, useState,useRef } from "react";
import {
  TableOutlined,
  CalendarOutlined,
  HeatMapOutlined,
  LogoutOutlined,
  SwapOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  SnippetsOutlined,
  CaretUpOutlined,
  ScheduleOutlined,
  GoldOutlined,
  BellOutlined,
  ProductOutlined
} from "@ant-design/icons";
import "./styles/App.css";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useParams,
  Outlet,
  Navigate,

} from "react-router-dom";
import { Layout, Menu, theme, message, Breadcrumb , Spin,notification , Badge} from "antd";
// import SuiteView from "./components/SuiteView";
import { useSelector, useDispatch } from "react-redux";
import TenantView from "./components/TenantView";
import Dashboard from "./components/Dashboard";
import CalendarView from "./components/CalendarView";
import RentalView from "./components/RentalView";
import DynamicForm from "./dynamicform/Form";
import LoginRegister from "./components/LoginRegister";
import ResetPassword from "./components/ResetPassword";
import WorkspaceSelector from "./components/WorkspaceSelector";
import ProtectedRoute from "./components/ProtectedRoute";
import { logout, initializeAuth } from "./features/authSlice";
import Events from "./components/Events";
import EventView from "./components/EventView";
import InvoiceBuilder from "./components/invoicebuilder/InvoiceBuilder";
import LeadsView from "./components/LeadsView";
import apiAction from "./ajax/service";
import { setPreload } from "./features/workspaceSlice";
import { debounce, deleteCookie, isEmpty } from "./helpers/helper";
import WorkspaceSettingsView from "./components/WorkspaceSettingsView";
import { getWorkspaceSettings } from "./interfaces/workspaceSettingsInterface";
import InvoiceView from "./components/InvoiceView";
import EventCalendar from "./components/EventCalendarView";
import { setError } from "./features/errorSlice";
import TemplatePreview from "./components/invoicebuilder/components/PreviewTemplate";
import Float from "./components/atoms/Float";
import NotificationManager from "./components/atoms/rentlog/NotificationManager";
import NoPermission from "./components/atoms/NoPermission";
import PersistantRef from "./components/atoms/PersistantRef";
import ProductPage from "./components/productpage/ProductPage";

const { Content, Sider } = Layout;

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      sessionStorage.setItem("lastRoute", location.pathname);
    }
  }, [location]);

  return null;
}


const routeKeys = {
  rental: "/dashboard",
  tenant: "/tenants",
  event: "/events",
  calendar: "/calendar",
  invoice: "/invoice-builder",
  "workspace-settings":'/workspace-settings',
  pricing:"pricing",
  leads: "/leads",
  forms:"/form",
  productpage:'/productpage'
};

// Helper for menu items
function getItem(label, key, icon, children = null) {
  return { key, icon, children, label };
}

// -----------------------------
// MainLayout Component
// -----------------------------
const MainLayout = ({constants}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const error = useSelector(state=>state.error.error)
  const preloadConstants = useSelector(state=>state.workspace?.preload?.constants)
  const userEmail = useSelector(state=>state.workspace?.loggedInUser)
  const slug = useSelector(state=>state.workspace?.plan?.slug)
  const notifications = useSelector(state=>state.workspace?.notifications)
  const [api, contextHolder] = notification.useNotification();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [collapsed, setCollapsed] = useState(true);
  useEffect(() =>{
    if (error?.length == 0) return
    api.error({
      message: preloadConstants?.error_titles?.[error] || "Operation Failed",
      description: preloadConstants?.error_descriptions?.[error] || error,
      className: "error-toast",
      placement: "topRight",
      duration: 8,
      style: {
        width: 420,
        borderRadius: 8,
        fontSize: 14,
        lineHeight: "20px",
      },
    });

    setTimeout(()=>dispatch(setError()),5000)
    // dispatch(setError())
  },[error])
  // Check if current route is invoice-builder
  const isInvoiceBuilder = location.pathname.startsWith("/invoice-builder");

  // Compute active key for menu highlight
  const activeRouteKey = (() => {
    const match = Object.keys(routeKeys).find((k) =>
      location.pathname.includes(k)
    );
    return match ? routeKeys[match] : "/dashboard";
  })();

  // Menu items
  const mainMenuItems = [
    getItem(constants["PRODUCT_GROUP_NAME"] ?? "Rental", "/dashboard", <TableOutlined />),
    getItem(constants["SALES_SUITE_NAME"] ?? "Events", "/events", <ScheduleOutlined />),
    getItem(constants["CONSUMER_GROUP_NAME"] ?? "Tenants", "/tenants", <UsergroupAddOutlined />),
    getItem("Calendar", "/calendar", <CalendarOutlined />),
    getItem("Invoice", "/invoice-builder", <SnippetsOutlined />),
    getItem("Service Request", "/leads", <UsergroupAddOutlined />),
    getItem("Product Page", "/productpage", <ProductOutlined />),
  ];

  const bottomMenuItems = [
    getItem("Upgrade & Pricing", "pricing", <GoldOutlined/>),
    getItem("Manage Workspace", "/workspace-settings", <SettingOutlined />),
    getItem("Switch Workspace", "switch_workspace", <SwapOutlined />),
    getItem("Logout", "logout", <LogoutOutlined />),
  ];

  // Handle menu click
  const handleMenuClick = async (e) => {
    if (e.key === "logout") {
      await apiAction('auth',{workspaceId:sessionStorage.getItem('selectedWorkspace'),email:userEmail},'logout')
      dispatch({ type: "RESET_APP" })

      dispatch(logout());
      message.success("Logged out successfully");
      navigate("/login");
      deleteCookie("tempAuthToken")
      PersistantRef.clearAll()
      sessionStorage.clear()
    } else if (e.key === "switch_workspace") {

      sessionStorage.clear()
      await apiAction("auth",{},"switch_workspace")
      dispatch({ type: "RESET_APP" })
      sessionStorage.removeItem('lastRoute')
      navigate("/workspace-selector");
      PersistantRef.clearAll()
    } else if (e.key === "/workspace-settings") {
      navigate("/workspace-settings")
    } else {

      navigate(e.key);
    }
    // ⬅️ Close immediately after click if on invoice-builder
    if (isInvoiceBuilder) setCollapsed(true);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {sessionStorage.getItem("selectedWorkspace")?.length > 0 && <Float />}
      {contextHolder}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
      >
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

          {/* ── LOGO HEADER ── */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: collapsed ? 0 : 10,
            padding: collapsed ? "16px 0" : "14px 16px",
            justifyContent: collapsed ? "center" : "flex-start",
            borderBottom: "1px solid #1e2533",
            transition: "all 0.25s ease",
            overflow: "hidden",
            minHeight: 64,
          }}>
            <img
              src="/logo1.png"
              style={{
                width: collapsed ? 25 : 35,
                height: collapsed ? 25 : 35,
                objectFit: "contain",
                borderRadius: 8,
                flexShrink: 0,
                transition: "all 0.25s ease",
              }}
            />
{!collapsed && (
  <div className="flex flex-col items-start leading-tight">

    <span className="text-white font-semibold text-base tracking-tight">
      ScaleFlow
    </span>

    {slug && (
      <span
        className={`
          mt-1 inline-block text-[10px] font-semibold uppercase tracking-wider px-2 py-[2px] rounded-full
          ${slug.toLowerCase() === "trial"
            ? "text-white/50 border border-white/20"
            : "text-white bg-gradient-to-r from-blue-500 to-violet-500 shadow-[0_0_10px_rgba(59,130,246,0.6)]"}
        `}
      >
        {slug}
      </span>
    )}
  </div>
)}
          </div>

          {/* ── MAIN MENU ── */}
          <div style={{ flex: "1 1 auto", minHeight: 0 }}>
            <Menu
              theme="dark"
              mode="inline"
              items={mainMenuItems}
              selectedKeys={[activeRouteKey]}
              onClick={handleMenuClick}
            />
          </div>
          { !collapsed ?
          <NotificationManager notifications={notifications ?? []} /> :<div
      className="relative mx-auto my-2.5"
      style={{ width: 40 }}> <div className="w-10 h-10 rounded-xl bg-[#161d2e] border border-[#1e2d45] flex items-center justify-center cursor-pointer hover:bg-[#1e2d45] transition-colors">
        <Badge count={notifications?.length || 0} size="small" offset={[4, -4]}>
          <BellOutlined style={{ color: "#8b9ab5", fontSize: 17 }} />
        </Badge></div>
      </div>
          }

          {/* ── BOTTOM MENU ── */}
          <div style={{ flex: "0 0 auto" }}>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #424242",
                margin: "8px 16px",
              }}
            />
            <Menu
              theme="dark"
              mode="inline"
              items={bottomMenuItems}
              selectedKeys={[activeRouteKey]}
              onClick={handleMenuClick}
              style={{ background: "transparent", border: "none" }}
            />
          </div>

        </div>
      </Sider>

      <Layout style={{ display: "flex", flexDirection: "column", overflowY: "auto" }}>
        {/* 🔹 Floating Breadcrumb (with icons) */}
        {/* <FloatingBreadcrumb /> */}
        <RouteTracker/>

        <Content
          style={{
            margin: "8px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: 10,
              minHeight: 0,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

// -----------------------------
// Main App Component
// -----------------------------

const App = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const preloadData = useSelector((state) => state.workspace.preloadComplete)
  const workspaceSettingsLoaded = useSelector((state)=>state.workspace.configLoaded)
  const constants = useSelector(state=>state.workspace.constants)
  const slug = useSelector(state=>state.workspace?.plan?.slug)
  const graceEndsAt = useSelector(state=>state.workspace?.plan?.graceEndsAt)
  const allowForms = useSelector(state=>state.workspace?.role?.forms?.allowFormPosting)
  const navigate = useNavigate();
  const initialLocation = '/dashboard'

const [showExpiredBanner , setShowExpiredBanner] = useState(false)
useEffect(()=>{
  if (!isAuthenticated) {
    return ;
  };

  if (!preloadData){
    apiAction('preload',{},"get").then((data)=>dispatch(setPreload(data)))
      .catch(()=>{/* optional error handling */});
  } else if (!workspaceSettingsLoaded && sessionStorage.getItem("selectedWorkspace")){
    getWorkspaceSettings(dispatch, sessionStorage.getItem("selectedWorkspace"));
  }
}, [preloadData, isAuthenticated, workspaceSettingsLoaded]);


  // Initialize auth state
  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(initializeAuth());
    } else if (sessionStorage.getItem("selectedWorkspace")!==null) {

    initNavigateMe()
    if(localStorage.getItem('showSplash') === 'true'){
      NavigateMe.startGuide("onboarding")
      localStorage.setItem('showSplash',false)
    }
      navigate(sessionStorage.getItem('initialLocation') || initialLocation );
    } else {

      navigate("/workspace-selector");
    }
  }, [isAuthenticated]);

  // Save current route before reload
  useEffect(() => {
  const handler = () => {
    const path = sessionStorage.getItem('lastRoute');

    if (!path.includes("login") && !path.includes("form")) {
      sessionStorage.setItem("initialLocation", path);
    }
  };

  window.addEventListener("beforeunload", handler);
  return () => window.removeEventListener("beforeunload", handler);
}, []);
useEffect(()=>{

if(graceEndsAt){
  const diff = Math.abs(Date.now() - new Date(graceEndsAt).getTime());
  const isLessThan14Days = diff < 15 * 24 * 60 * 60 * 1000;

  if(isLessThan14Days){
      setShowExpiredBanner(true)
  }
}
},[graceEndsAt])

  // console.log(isAuthenticated,workspaceSettingsLoaded,preloadData,showExpiredBanner,graceEndsAt)
  // console.log('App render', { isAuthenticated, preloadData, workspaceSettingsLoaded, constantsLen: Object.keys(constants).length });

  // if ((!isAuthenticated && !workspaceSettingsLoaded && !preloadData )){
  //   return <Spin fullscreen>Loading.....</Spin>
  // }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginRegister />} />


      <Route path="/reset-password/:email/:token" element={<ResetPassword />} />
       <Route
    path="/workspace-selector"
    element={
      <ProtectedRoute>
        <WorkspaceSelector />
      </ProtectedRoute>
    }
  />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout constants={constants} />
          </ProtectedRoute>
        }
      >

        <Route index element={<Navigate to="/dashboard" />} />
<Route
  path="pricing"
  element={(() => {
    const isTrial   = slug && slug.toLowerCase() === "trial";
    const isExpired = (!isTrial && showExpiredBanner ) || !graceEndsAt;
    const isActive  = !isTrial && !showExpiredBanner;

    const banner = isTrial && showExpiredBanner ? {
      emoji: "⏳",
      style: "bg-gradient-to-r from-purple-600 to-violet-500 shadow-violet-500/30",
      message: (
        <>
          Your <strong>trial</strong> will expire by{" "}
          <strong>
            {new Date(graceEndsAt).toLocaleString("en-IN", {
              year: "numeric", month: "short", day: "numeric",
              hour: "2-digit", minute: "2-digit",
            }) || "or already expired."}
          </strong>. Upgrade now to keep access.
        </>
      ),
    } : isExpired ? {
      emoji: "⏳",
      style: "bg-gradient-to-r from-yellow-500 to-amber-400 shadow-amber-400/30",
      message: (
        <>
          Your existing license will expire by{" "}
          <strong>
            {new Date(graceEndsAt).toLocaleString("en-IN", {
              year: "numeric", month: "short", day: "numeric",
              hour: "2-digit", minute: "2-digit",
            })}
          </strong>. No action needed if autopay is enabled.
        </>
      ),
    } : isActive ? {
      emoji: "⚠️",
      style: "bg-gradient-to-r from-red-600 to-orange-500 shadow-orange-500/30",
      message: <>You already have a running subscription, so you cannot subscribe again. To change your subscription, please contact support using the button in the bottom right of the page.</>,
    } : null;

    return (
      <>
        {banner && (
          <div className={`flex items-center gap-3 text-white px-5 py-3 rounded-lg shadow-lg mb-2 text-sm font-medium ${banner.style}`}>
            <span className="text-lg">{banner.emoji}</span>
            <span>{banner.message}</span>
          </div>
        )}

        {/* Show info bar in all conditions EXCEPT active running subscription */}
        {!isActive && (
          <div className="flex items-center gap-2 text-blue-700 bg-blue-50 border border-blue-200 px-5 py-2.5 rounded-lg mb-4 text-sm">
            <span>ℹ️</span>
            <span>
              After a successful subscription, please <strong>log out and log back in</strong> for the changes to take effect immediately.
            </span>
          </div>
        )}

        <TemplatePreview url={"/api/template/pricing"} runscripts={true} />
      </>
    );
  })()}
/>
        <Route path="tour" element={<TemplatePreview inIFrame={true}  url={"/api/template/tour"} runscripts={true} />}/>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="eventcalendar" element={<EventCalendar />} />
        <Route path="calendar" element={<CalendarView />} />
        <Route path="rental/:id" element={<RentalView />} />
        <Route path="tenants" element={<TenantView />} />
        <Route path="form/:modal" element={allowForms?<DynamicForm />:<NoPermission/>} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:id" element={<EventView />} />
        {/* <Route path="/suite/:id" element={<SuiteView />} /> */}
        <Route path="/invoice" element={<InvoiceView />} />
        <Route path="/invoice-builder" element={<InvoiceBuilder />} />
        <Route path="workspace-settings" element={allowForms?<WorkspaceSettingsView />:<NoPermission/>} />
        <Route path="/leads" element={<LeadsView />} />
        <Route path="/productpage" element={<ProductPage />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
};

export default App;
